module.exports = __webpack_public_path__ + "media/images/drivu_white_logo2-5639377451cbf7ef6ac76b2b57ed7863.png";